// extracted by mini-css-extract-plugin
module.exports = {"outside":"ButtonCrusher_outside__9CxkW","inside":"ButtonCrusher_inside__1awsm"};